import { flexRender, getCoreRowModel, useReactTable } from "@tanstack/react-table";
import React, { FC, useEffect, useState } from "react";
import { API_URL } from "../../../../actions/settings";
import LoadingSpinner from "../../../extras/LoadingSpinner";

interface IProps {
    building:string,
    type:string
};
async function getData(token: string,id:string) {
  return fetch(`${API_URL}/incentive_forecast/data/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
            console.log('error')
            res.json().then( err => {
                console.log("Error", err)
                return false
                // throw error here to use the catch
            })

        }
      }).catch(error => {
        console.log(error)
      });
}

const IncentiveDataTable:FC<IProps> = (props) => {
    const [loading,setLoading] = useState(true)
    const [data, setData] = useState<any>(null)

    useEffect(()=>{
        const handleResults = async () => {
            const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
            const res = await getData(token,props.building)
            if(res.status === 'success'){
                setData(res.data)
            }
            setLoading(false)
        };
        handleResults()
    },[props.building])
    
    let columns:any = [
        {
          id:'date',
          accessorKey:'month',
          header: "Month",
          cell: (props: any) => {
            return (
              <div className="center-all">{props.getValue()}</div>
            );
          },
          size: 70,
          enableColumnFilter: false,
          enableGlobalFilter: false,
        },
        {
          id:`current_${props.type}`,
          accessorKey:`${props.type}`,
          header: `Current ${props.type === 'therms' ? 'Therms' : 'kWh'}`,
          cell: (props: any) => {
            return (
              <div className="center-all">{Math.round(props.getValue())}</div>
            );
          },
          size: 150,
          enableColumnFilter: false,
          enableGlobalFilter: false,
        },
        {
            id:`baseline_${props.type}`,
            accessorKey: `baseline_${props.type}`,
            header: `Baseline ${props.type === 'therms' ? 'Therms' : 'kWh'}`,
            cell: (props: any) => {
                return (
                <div className="center-all">{Math.round(props.getValue())}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:`adjusted_${props.type}`,
            accessorKey: `adjusted_${props.type}`,
            header: `Adjusted ${props.type === 'therms' ? 'Therms' : 'kWh'}`,
            cell: (props: any) => {
                return (
                <div className="center-all">{Math.round(props.getValue())}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:`target_${props.type}`,
            accessorKey: `target_${props.type}`,
            header: `Target ${props.type === 'therms' ? 'Therms' : 'kWh'}`,
            cell: (props: any) => {
                return (
                <div className="center-all">{Math.round(props.getValue())}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:`adjusted_target_${props.type}`,
            accessorKey: `adjusted_target_${props.type}`,
            header: `Adjusted Target ${props.type === 'therms' ? 'Therms' : 'kWh'}`,
            cell: (props: any) => {
                return (
                <div className="center-all">{Math.round(props.getValue())}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
    ]
    

    const table = useReactTable({
        data: data,
        columns: columns,
        getCoreRowModel: getCoreRowModel(),
      });

    if(loading){
        return <LoadingSpinner/>
    }

    return <div style={{width:'100%',marginTop:'0.5rem', display:'flex', justifyContent:'center',textAlign:'center'}}>
    <div className="data-table" style={{ width: table.getTotalSize(), marginBottom: "2em", overflowX: "auto", maxHeight:'550px'}}>
        {table.getHeaderGroups().map((headerGroup: any) => (
          <div key={headerGroup.id} className="tr">
            {headerGroup.headers.map((header: any) => {
              return (
                <div
                  key={header.id}
                  className="th"
                  style={{ width: header.getSize() }}

                >
                  {header.column.columnDef.header}
                </div>
              );
            })}
          </div>
        ))}

        {table.getRowModel().rows.map((row: any) => (
          <div
            key={row.id}
            className="tr"
            style={{ width: table.getTotalSize() }}
          >
            {row.getVisibleCells().map((cell: any) => {
              return (
                <div
                  key={cell.id}
                  className="td"
                  style={{ width: cell.column.getSize() }}
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </div>
              );
            })}
          </div>
        ))}
        
    </div>
    </div>
};

export default IncentiveDataTable;